import React, { useContext, useState } from 'react';
import { colorSet } from '@components/Provider';
import { Box, makeStyles } from '@material-ui/core';
import { HomeComponentContainer } from './styled';
import { CustomizedTypography } from '@components/Customized';
import { Pagination } from '@material-ui/lab';
import { ArrowForward } from '@material-ui/icons';
import usePagination from './usePagenation';
import { MediaQuery } from '../HomePresenter';
import useUserActionLog, {
  Enum_Action_Button_Enum,
  CapaActivityType
} from '@hooks/useUserActionLog';

const PER_PAGE = 5;
const NewsData = [
  {
    company: '전자신문',
    date: '2023.01.31',
    title: `[CEO 기고] 제조업의 '파운드리' 생태계를 준비하자`,
    link: 'https://n.news.naver.com/mnews/article/030/0003075647?sid=110'
  },
  {
    company: '머니투데이',
    date: '2023.01.27',
    title: `제조업계의 네이버 '캐파' 운영사 에이팀벤처스, 50억 투자유치`,
    link: 'https://n.news.naver.com/mnews/article/008/0004844314?sid=101'
  },
  {
    company: '전자신문',
    date: '2022.11.24',
    title: `온라인 제조 플랫폼 CAPA, 한글 브랜드명 '캐파'로 변경`,
    link: 'https://n.news.naver.com/mnews/article/030/0003061547?sid=101'
  },
  {
    company: '한국경제',
    date: '2022.10.28',
    title: `[CEO 기고] 세계는 제조업 전쟁…누구를 데리고 싸울 것인가`,
    link: 'https://n.news.naver.com/mnews/article/015/0004768466?sid=105'
  },
  {
    company: '전자신문',
    date: '2022.10.18',
    title: `[CEO 기고] '피그마'(Figma) 인수의 교훈`,
    link: 'https://n.news.naver.com/mnews/article/030/0003052023?sid=100'
  },
  {
    company: '물류신문',
    date: '2022.09.30',
    title: `에이팀벤처스(주)-케이로지(주) 업무협약 체결`,
    link: 'http://www.klnews.co.kr/news/articleView.html?idxno=305744'
  },
  {
    company: '한국경제',
    date: '2022.08.25',
    title: `한국 최초 우주인 후보였던 男, 요즘 뭐하나 봤더니… `,
    link: 'https://n.news.naver.com/mnews/article/015/0004741361?sid=105'
  },
  {
    company: 'MFG',
    date: '2022.01.03',
    title: `“아직도 이메일로 ‘도면’을 주고받는다고요?” 에이팀벤처스, 도면에 특화된 협업 툴 ‘캐파 커넥트’ 출시`,
    link: 'http://www.mfgkr.com/archives/21126'
  },
  {
    company: '매일경제',
    date: '2022.07.19',
    title: `협업툴의 무한 진화…영상회의는 물론, 공유문서에 피드백도`,
    link: 'https://n.news.naver.com/mnews/article/009/0004993143?sid=105'
  },
  {
    company: '신동아',
    date: '2022.07.08',
    title: `[인터뷰] "이제는 글로벌 유니콘 스타트업 꿈꿀 때"`,
    link: 'https://n.news.naver.com/mnews/article/262/0000015699?sid=100'
  },
  {
    company: '전자신문',
    date: '2022.06.28',
    title: `누리호 발사 성공, 대한민국 제조업 승리`,
    link: 'https://n.news.naver.com/mnews/article/030/0003026390?sid=110'
  },
  {
    company: '서울신문',
    date: '2022.06.15',
    title: `“제조업 살리려면 산업단지부터 ‘번듯한 일터’로 업그레이드해야”`,
    link: 'https://n.news.naver.com/mnews/article/081/0003280166?sid=102'
  },
  {
    company: '뉴시스',
    date: '2022.05.26',
    title: `고산 에이팀벤처스 대표 "제조업 생태계 바꾸는 게 꿈"`,
    link: 'https://n.news.naver.com/mnews/article/003/0011209423?sid=101'
  },
  {
    company: '이투데이',
    date: '2022.05.26',
    title: `"10년 안에 10억명, 제조업 종합 커뮤니티로 키운다"`,
    link: 'https://www.etoday.co.kr/news/view/2137355'
  },
  {
    company: '이투데이',
    date: '2022.05.04',
    title: `에이팀벤처스, 도면 특화 협업 툴 '캐파 커넥트' 출시`,
    link: 'https://www.etoday.co.kr/news/view/2130613'
  },
  {
    company: '포브스',
    date: '2021.12.23',
    title: '김익환이 만난 혁신 기업가(31) 고산 에이팀벤처스 대표',
    link: 'https://jmagazine.joins.com/forbes/view/335139'
  },
  {
    company: 'MFG',
    date: '2021.12.13',
    title: '3세대 제조업 플랫폼, 캐파(CAPA)의 탄생',
    link: 'http://www.mfgkr.com/archives/19757'
  },
  {
    company: '잡스엔',
    date: '2021.10.25',
    title: '제조업의 네이버·쿠팡을 만들 겁니다',
    link:
      'https://m.post.naver.com/viewer/postView.naver?volumeNo=32616953&memberNo=27908841'
  },
  {
    company: 'JTBC',
    date: '2021.10.21',
    title: '고산 "우주인 배출 10여 년 만에 발사, 그 자체가 큰 발전"',
    link: 'https://news.jtbc.joins.com/article/article.aspx?news_id=NB12027797'
  },
  {
    company: '월간조선',
    date: '2021.10.06',
    title: '“제조 플랫폼 시장의 ‘아마존’ 될 것”',
    link:
      'https://m.monthly.chosun.com/client/news/viw.asp?ctcd=H&nNewsNumb=202110100033'
  },
  {
    company: '조선일보',
    date: '2021.09.09',
    title:
      '“도면만 주면 생산은 걱정마세요”...15년전 제프 베이조스가 찍었던 이 산업',
    link:
      'https://www.chosun.com/economy/tech_it/2021/09/09/XAT44BK345EFTBTUDQVOVKEP3M/'
  },
  {
    company: '월간조선',
    date: '2021.09.08',
    title: '캐파(CAPA), ITP와 손잡고 인천 지역 제조업 활성화 나선다',
    link:
      'http://m.monthly.chosun.com/client/mdaily/daily_view.asp?idx=13397&Newsnumb=20210913397'
  },
  {
    company: '국제신문',
    date: '2021.07.18',
    title: '청년과, 나누다 3 <4> 고산 에이팀벤처스 대표',
    link:
      'http://www.kookje.co.kr/news2011/asp/newsbody.asp?code=0300&key=20210719.22006004518'
  },
  {
    company: '이코노미 조선',
    date: '2021.06.15',
    title: '“글로벌 온라인 제조 플랫폼으로 도약”',
    link:
      'https://biz.chosun.com/industry/company/2021/06/15/QZVYYG2SNJAWZII2PKO5GULYCE/ '
  },
  {
    company: '조선일보',
    date: '2021.05.14',
    title:
      '한국 첫 우주인 후보서 플랫폼 사업가로… “온라인서 부품 제조 실시간 견적 서비스”',
    link:
      'https://www.chosun.com/economy/economy_general/2021/05/14/L3KF7QNAWJBRLFTYWCLRHDXTTI/ '
  },
  {
    company: '한국경제신문',
    date: '2021.01.05',
    title: `'한국 첫 우주인' 고산의 에이팀벤처스 "아이디어-공장 24시간 비대면 연결”`,
    link: 'https://www.hankyung.com/it/article/2021010500961'
  }
];

const CapaNews = () => {
  const { mainTitle, newsContent, newsContainer } = useStyles();
  const { md, sm } = useContext(MediaQuery);
  const [page, setPage] = useState(1);
  const count = Math.ceil(NewsData.length / PER_PAGE);
  const _DATA = usePagination(NewsData, PER_PAGE);
  const { onInsertUserActionLogOne } = useUserActionLog();

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
    _DATA.jump(value);
  };

  const onOpenLink = (link: string) => {
    onInsertUserActionLogOne(
      Enum_Action_Button_Enum.Landing_PRESS_LIST,
      CapaActivityType.ButtonClick
    );
    return window.open(link);
  };

  return (
    <>
      <HomeComponentContainer
        padding={sm ? '100px  16px' : md ? '120px 36px' : '140px 0'}
      >
        <CustomizedTypography
          variant="h1"
          fontWeight="700"
          align="left"
          className={mainTitle}
        >
          언론이 주목한 캐파
        </CustomizedTypography>
        <Box className={newsContainer}>
          {_DATA.currentData().map((item, idx) => {
            return item.link ? (
              <Box
                key={idx}
                className={newsContent}
                onClick={() => {
                  item.link.length > 0 && onOpenLink(item.link);
                }}
              >
                <div>
                  <div className="newsCompany">
                    <CustomizedTypography
                      variant={sm ? 'subtitle2' : 'body2'}
                      color="primary"
                    >
                      {item.company}
                    </CustomizedTypography>
                    <CustomizedTypography
                      variant={sm ? 'subtitle2' : 'body2'}
                      className="contentDate"
                    >
                      {item.date}
                    </CustomizedTypography>
                  </div>
                  <CustomizedTypography
                    className="itemTitle"
                    variant={sm ? 'body1' : 'h4'}
                    fontWeight="500"
                  >
                    {item.title}
                  </CustomizedTypography>
                </div>
                {!sm && (
                  <div className="arrowIcon">
                    <ArrowForward />
                  </div>
                )}
              </Box>
            ) : (
              <Box key={idx} className="emptyBox"></Box>
            );
          })}
        </Box>
        <Pagination
          count={count}
          size="medium"
          page={page}
          onChange={handleChange}
        />
      </HomeComponentContainer>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  mainTitle: {
    marginBottom: 48,
    width: 960,
    [theme.breakpoints.down('md')]: {
      width: 888
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      minWidth: 343,
      fontSize: '28px'
    }
  },
  newsContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 32,
    minHeight: 625,
    '& .emptyBox': {
      minHeight: 117,
      borderBottom: `1px solid ${colorSet.gray200}`
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 594
    }
  },
  newsContent: {
    display: 'flex',
    flexDirection: 'row',
    maxWidth: 960,
    height: 117,
    borderBottom: `1px solid ${colorSet.gray200}`,
    padding: '28px 28px 29px 0',
    justifyContent: 'space-between',
    cursor: 'pointer',
    '& .newsCompany': {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      gap: '8px',
      marginBottom: 8,
      '& .contentDate': {
        color: colorSet.gray600
      }
    },
    '& .itemTitle': {
      transition: 'all 0.2s ease-in-out'
    },
    '& .arrowIcon': {
      transition: 'all 0.2s ease-in-out',
      paddingTop: '23px',
      color: colorSet.gray500
    },
    '&:hover': {
      '& .itemTitle': {
        color: colorSet.gray700
      },
      '& .arrowIcon': {
        color: colorSet.gray900,
        transform: 'translateX(8px)'
      }
    },
    [theme.breakpoints.down('sm')]: {
      padding: '31px 0'
    }
  }
}));

export default CapaNews;
